// frontend/src/components/event/EventFormatBadge.js
import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Monitor, MapPin, Combine } from "lucide-react";

const EventFormatBadge = ({ format, size = "md" }) => {
  const { t } = useLanguage();

  const formatConfig = {
    online: {
      label: { de: "Online", en: "Online" },
      icon: Monitor,
      color: "bg-blue-500 text-white",
    },
    in_person: {
      label: { de: "Vor Ort", en: "In-Person" },
      icon: MapPin,
      color: "bg-green-500 text-white",
    },
    hybrid: {
      label: { de: "Hybrid", en: "Hybrid" },
      icon: Combine,
      color: "bg-purple-500 text-white",
    },
  };

  const config = formatConfig[format] || formatConfig.online;
  const Icon = config.icon;

  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-2.5 py-1",
    lg: "text-base px-3 py-1.5",
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md font-medium ${config.color} ${sizeClasses[size]}`}
    >
      <Icon className={iconSizes[size]} />
      {t(config.label)}
    </span>
  );
};

export default EventFormatBadge;
